// This file was automatically generated from print.report.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.report');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.print.report.patientForm');
goog.require('el8.template.print.resultGrid');
goog.require('el8.template.print');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.report.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.report.resultGrids.length) {
    output.append('<div class="pageWrap2 pageBreak">');
    el8.template.print.header(opt_data, output);
    el8.template.print.currentAsOf(opt_data, output);
    output.append('<h1 class="documentTitle">', soy.$$escapeHtml(opt_data.report.displayReportName), '</h1>');
    el8.template.print.patientInfo(opt_data, output);
    output.append('<div class="pv5"></div>');
    el8.template.print.report.fileAndOrderDetail(opt_data, output);
    var gList16952 = opt_data.report.resultGrids;
    var gListLen16952 = gList16952.length;
    for (var gIndex16952 = 0; gIndex16952 < gListLen16952; gIndex16952++) {
      var gData16952 = gList16952[gIndex16952];
      el8.template.print.resultGrid.content(soy.$$augmentData(gData16952, {isTxResultOnly: opt_data.report.txResultOnly}), output);
    }
    el8.template.print.resultGrid.abnormalFlagLegend(opt_data.report, output);
    if (opt_data.report.labCenters && opt_data.report.labCenters.length) {
      output.append('<p class="extraSmallText pt5"><b>Testing Center Information:</b></p>');
      var centerList16960 = opt_data.report.labCenters;
      var centerListLen16960 = centerList16960.length;
      for (var centerIndex16960 = 0; centerIndex16960 < centerListLen16960; centerIndex16960++) {
        var centerData16960 = centerList16960[centerIndex16960];
        el8.template.print.resultGrid.labCenter(centerData16960, output);
      }
    }
    el8.template.print.signature(soy.$$augmentData(opt_data.report, {signPhysicianName: opt_data.report.signUserName, localFsPath: opt_data.localFsPath}), output);
    output.append('</div>');
  }
  var urlList16967 = opt_data.report.fullSizeImages;
  var urlListLen16967 = urlList16967.length;
  for (var urlIndex16967 = 0; urlIndex16967 < urlListLen16967; urlIndex16967++) {
    var urlData16967 = urlList16967[urlIndex16967];
    output.append('<div class="pageBreak pageWrap"><img class="el8MaxWidth100" src="', soy.$$escapeHtml(urlData16967), '" />');
    if (urlIndex16967 == urlListLen16967 - 1) {
      el8.template.print.signature(soy.$$augmentData(opt_data.report, {signPhysicianName: opt_data.report.signUserName, localFsPath: opt_data.localFsPath, receiveDate: opt_data.report.createDate}), output);
    }
    output.append('</div>');
  }
  if (opt_data.report.externalReportAttachments.length) {
    output.append('<div class="pageWrap2 pageBreak">');
    el8.template.print.header(opt_data, output);
    el8.template.print.currentAsOf(opt_data, output);
    output.append('<h1 class="documentTitle">', soy.$$escapeHtml(opt_data.report.displayReportName), '</h1>');
    el8.template.print.patientInfo(opt_data, output);
    output.append('<div class="pv5"></div>');
    el8.template.print.report.receiveDetail(opt_data, output);
    var externalReportAttachmentList16990 = opt_data.report.externalReportAttachments;
    var externalReportAttachmentListLen16990 = externalReportAttachmentList16990.length;
    for (var externalReportAttachmentIndex16990 = 0; externalReportAttachmentIndex16990 < externalReportAttachmentListLen16990; externalReportAttachmentIndex16990++) {
      var externalReportAttachmentData16990 = externalReportAttachmentList16990[externalReportAttachmentIndex16990];
      el8.template.print.resultGrid.externalReportContent({externalReportAttachment: externalReportAttachmentData16990}, output);
    }
    el8.template.print.signature(soy.$$augmentData(opt_data.report, {signPhysicianName: opt_data.report.signUserName, localFsPath: opt_data.localFsPath, receiveDate: opt_data.report.createDate}), output);
    output.append('</div>');
  }
  if (opt_data.report.formCollection) {
    output.append('<div class="pageWrap2 pageBreak">');
    el8.template.print.header(opt_data, output);
    el8.template.print.currentAsOf(opt_data, output);
    output.append('<h1 class="documentTitle">', (opt_data.report.displayVendorName) ? soy.$$escapeHtml(opt_data.report.displayVendorName) + ' ' : '', soy.$$escapeHtml(opt_data.report.displayReportName), '</h1>');
    el8.template.print.patientInfo(opt_data, output);
    output.append('<br />');
    el8.template.print.report.patientForm.content({formCollection: opt_data.report.formCollection, reportCreateDate: opt_data.report.createDate, receiveDate: opt_data.report.createDate}, output);
    output.append('</div>');
  }
  if (! opt_data.report.externalReportAttachments.length && ! opt_data.report.resultGrids.length && ! opt_data.report.fullSizeImages.length && ! opt_data.report.formCollection) {
    output.append('<div class="pageWrap pageBreak">');
    el8.template.print.header(opt_data, output);
    output.append('<h1 class="documentTitle">Report</h1><div class="el8NoImageError">Image Not Available</div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.report.fileAndOrderDetail = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<table class="w100 extraSmallText"><tr><td class="w50">File Received: ', (soy.$$escapeHtml(opt_data.report.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.report.createDate)) : ''), '</td><td class="w50 alignRight">Requisition No.: ', (opt_data.report.lastManualEditTime) ? 'N/A' : soy.$$escapeHtml(opt_data.report.requisitionNumber), '</td></tr><tr><td class="w50">Ordered By: ', (opt_data.report.orderingProviderName) ? soy.$$escapeHtml(opt_data.report.orderingProviderName) : 'N/A', '</td><td class="w50 alignRight"></td></tr>', (opt_data.report.fastingFlag) ? '<tr><td class="w50">Fasting: ' + soy.$$escapeHtml(opt_data.report.fastingFlag) + '</td><td class="w50 alignRight"></td></tr>' : '', '</table>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.report.receiveDetail = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<table class="w100 extraSmallText"><tr><td class="w50">Received: ', (soy.$$escapeHtml(opt_data.report.createDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.report.createDate)) : ''), '</td></tr></table>');
  if (!opt_sb) return output.toString();
};
